import React from "react";
import { ReactComponent as Instar } from "src/assets/sns/Instagram.svg";
import { ReactComponent as Twitter } from "src/assets/sns/TwitterX.svg";
import { ReactComponent as Blog } from "src/assets/sns/Internet.svg";
import { ReactComponent as Brunch } from "src/assets/sns/branch.svg";
import { ReactComponent as AddSns } from "src/assets/sns/Add circle.svg";
import { ReactComponent as PlusIcon } from "src/assets/plus.svg";
import { isValidHttpsUrl } from "../hooks/useAuthorRegisterForm";

interface SnsLinksSectionProps {
    isMobile: boolean;
    instarLink: string;
    setInstarLink: (value: string) => void;
    instarError?: string;
    instarRef: React.RefObject<HTMLInputElement>;
    twitterLink: string;
    setTwitterLink: (value: string) => void;
    twitterError?: string;
    twitterRef: React.RefObject<HTMLInputElement>;
    blogLink: string;
    setBlogLink: (value: string) => void;
    blogError?: string;
    blogRef: React.RefObject<HTMLInputElement>;
    brunchLink: string;
    setBrunchLink: (value: string) => void;
    brunchError?: string;
    brunchRef: React.RefObject<HTMLInputElement>;
    snsLinks: string[];
    onSnsLinkChange: (index: number, value: string) => void;
    onLinkAdd: () => void;
    snsExtraError?: string;
}

const SnsLinksSection: React.FC<SnsLinksSectionProps> = ({
    isMobile,
    instarLink,
    setInstarLink,
    instarError,
    instarRef,
    twitterLink,
    setTwitterLink,
    twitterError,
    twitterRef,
    blogLink,
    setBlogLink,
    blogError,
    blogRef,
    brunchLink,
    setBrunchLink,
    brunchError,
    brunchRef,
    snsLinks,
    onSnsLinkChange,
    onLinkAdd,
    snsExtraError,
}) => {
    return (
        <label className="flex flex-col gap-4" id="snsLink">
            <div className="">
                <span className="title">SNS 링크</span>
            </div>

            <div className="flex flex-col gap-1">
                <div className="flex w-full min-w-0 gap-3 items-center">
                    <Instar className="flex-shrink-0" />
                    <input
                        ref={instarRef}
                        className={`appearance-none min-w-0 flex-1 h-12 text-gray-700 border ${instarError ? "border-red-500 focus:outline-red-500" : instarLink ? "border-input focus:outline-input" : "border-extra placeholder-gray-400 focus:outline-input"} rounded py-3 px-4 leading-tight focus:text-black`}
                        onChange={(e) => setInstarLink(e.target.value)}
                        type="text"
                        placeholder="https://instagram.com/아이디"
                        value={instarLink}
                    />
                </div>
                {instarError && (
                    <p className="font-namsan text-[12px] font-bold text-red-500">{instarError}</p>
                )}
            </div>

            <div className="flex flex-col gap-1">
                <div className="flex w-full min-w-0 gap-3 items-center">
                    <Twitter className="flex-shrink-0" />
                    <input
                        ref={twitterRef}
                        className={`appearance-none min-w-0 flex-1 h-12 text-gray-700 border ${twitterError ? "border-red-500 focus:outline-red-500" : twitterLink ? "border-input focus:outline-input" : "border-extra placeholder-gray-400 focus:outline-input"} rounded py-3 px-4 leading-tight focus:text-black`}
                        type="text"
                        placeholder="https://x.com/아이디"
                        value={twitterLink}
                        onChange={(e) => setTwitterLink(e.target.value)}
                    />
                </div>
                {twitterError && (
                    <p className="font-namsan text-[12px] font-bold text-red-500">{twitterError}</p>
                )}
            </div>

            <div className="flex flex-col gap-1">
                <div className="flex w-full min-w-0 gap-3 items-center">
                    <Blog className="flex-shrink-0" />
                    <input
                        ref={blogRef}
                        className={`appearance-none min-w-0 flex-1 h-12 text-gray-700 border ${blogError ? "border-red-500 focus:outline-red-500" : blogLink ? "border-input focus:outline-input" : "border-extra placeholder-gray-400 focus:outline-input"} rounded py-3 px-4 leading-tight focus:text-black`}
                        type="text"
                        placeholder="https://blog.naver.com/아이디"
                        value={blogLink}
                        onChange={(e) => setBlogLink(e.target.value)}
                    />
                </div>
                {blogError && (
                    <p className="font-namsan text-[12px] font-bold text-red-500">{blogError}</p>
                )}
            </div>

            <div className="flex flex-col gap-1">
                <div className="flex w-full min-w-0 gap-3 items-center">
                    <Brunch className="flex-shrink-0" />
                    <input
                        ref={brunchRef}
                        className={`appearance-none min-w-0 flex-1 h-12 text-gray-700 border ${brunchError ? "border-red-500 focus:outline-red-500" : brunchLink ? "border-input focus:outline-input" : "border-extra placeholder-gray-400 focus:outline-input"} rounded py-3 px-4 leading-tight focus:text-black`}
                        onChange={(e) => setBrunchLink(e.target.value)}
                        type="text"
                        placeholder="https://brunch.co.kr/@아이디"
                        value={brunchLink}
                    />
                </div>
                {brunchError && (
                    <p className="font-namsan text-[12px] font-bold text-red-500">{brunchError}</p>
                )}
            </div>

            <div className={`flex flex-col gap-${isMobile ? "3" : "4"}`}>
                <div className={isMobile ? "flex flex-col items-center justify-center" : ""}>
                    <button
                        className="w-[140px] h-[38px] font-base rounded-full bg-main text-white flex items-center justify-center space-x-1.5 transition-all duration-200 active:scale-95"
                        type="button"
                        id="linkAdd"
                        onClick={onLinkAdd}
                    >
                        <PlusIcon className="w-4 h-4" />
                        <span className="font-namsan-B text-[13px]">SNS 링크 추가</span>
                    </button>
                </div>

                {snsLinks.map((link, index) => (
                    <div key={index} className="flex w-full min-w-0 gap-3 items-center">
                        <AddSns className="flex-shrink-0" />
                        <input
                            className={`appearance-none min-w-0 flex-1 h-12 text-gray-700 border ${snsExtraError && link && !isValidHttpsUrl(link) ? "border-red-500 focus:outline-red-500" : "border-extra placeholder-gray-400 focus:outline-input"} rounded py-3 px-4 leading-tight focus:text-black`}
                            type="text"
                            placeholder="https://"
                            value={link}
                            onChange={(e) => onSnsLinkChange(index, e.target.value)}
                        />
                    </div>
                ))}
                {snsExtraError && (
                    <p className="font-namsan text-[12px] font-bold text-red-500">
                        {snsExtraError}
                    </p>
                )}
            </div>
        </label>
    );
};

export default SnsLinksSection;
